import { useEffect } from 'react';
import { Box, Divider, Link } from '@mui/material';
import './EditUserProfile.scss';
import SPForm from '../../Form/SPForm';
import editUserProfileForm from '../../Form/json/editUserProfileFormFields.json';
import SPFormButton from '../../Form/SPFormButton';
//import { SpApiUpdateUser } from '../../../../pages/SellerProfile/APIs/SellerProfileAPI';
//import GetLabels from '../../../../pages/SellerProfile/GetLabels';
import { getUserInfoById } from '../../../../pages/SellerProfile/APIs/Helpers';
import { doFormErrorMsgs } from '../../../../pages/SellerProfile/APIs/Helpers';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { updateUserStart, resetSubmitSuccess, setFormLoading,setShowSuccessPopUp,setModalType } from '../../../../redux/slices/sellerProfileSlice';

export const EditUserProfile = ({ onRemove, curr_user_id }) => {
  const dispatch = useDispatch();
  const { users, saveUpdates, submitSuccess, formLoading,spPageText,formUpdates } = useSelector((state: any) => state.sellerProfile);
  useEffect(() => {
    dispatch(setFormLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //const [loading, setLoading] = useState(false);
  const formData = getUserInfoById(users, curr_user_id);

  const { t } = useTranslation();

 useEffect(() => {
    if (submitSuccess) {
      const successMsg = t('sellerProfile.dashboard.editUserProfileSuccess');
     dispatch(setModalType(''));
      dispatch(setShowSuccessPopUp(successMsg));
      dispatch(resetSubmitSuccess(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitSuccess])

  const submitFormFields = async (formName) => {
    try {
      dispatch(updateUserStart({
        formUpdates: formUpdates,
        curr_user_id
      }));
    } catch (error) {
      doFormErrorMsgs(error,dispatch, spPageText, false);
      dispatch(setShowSuccessPopUp({
        message: t('sellerProfile.dashboard.errorGeneral'),
        successType: 'error'
      }));
    }
  };

  return (
    <Box className="editUserCardPopupContainer">
      <Box className="editUserCardPopupBody">
        <SPForm
          cols="single"
          compName="editUserCardPopupForm editUser"
          formFields={editUserProfileForm}
          user_id={curr_user_id}
          formData={formData}
          formName="editUserProfile"
          key="editUserProfileForm"
        />
        <div className="editUserButtons">
          <Link
            onClick={() => onRemove()}
            onKeyDown={(e) => e.key === 'Enter' && onRemove()}
            className="removeUserButtonDT"
            tabIndex={0}
          >
            {t('sellerProfile.dashboard.removeUser')}
          </Link>
          {!formLoading && (
            <SPFormButton
              handleClick={() => submitFormFields('editUserProfile')}
              label={t('sellerProfile.dashboard.saveChanges')}
              compName="updateUserSettings"
              formName="editUserProfile"
              user_id={curr_user_id}
              showLoading={saveUpdates}
            />
          )}
          <Link
            onClick={() => onRemove()}
            onKeyDown={(e) => e.key === 'Enter' && onRemove()}
            className="removeUserButtonMobile"
            tabIndex={0}
          >
            {t('sellerProfile.dashboard.removeUser')}
          </Link>
        </div>
        {/* </Box> */}
        <Divider className="editUserPopupSizer" sx={{ opacity: 0 }} />
        {/* <Link className="viewNotificationsButton">
          {spPageText.viewNotifications}
        </Link> */}
      </Box>
    </Box>
  );
};
